export const isSandbox = (url: string): boolean => {
  return /sandbox(\.oci)?\.faire\.team/.test(url);
};
